var map = {
	"./author/frontend.js": "./src/block/author/frontend.js",
	"./blog-post/frontend.js": "./src/block/blog-post/frontend.js",
	"./deal-product/frontend.js": "./src/block/deal-product/frontend.js",
	"./nav-menu/frontend.js": "./src/block/nav-menu/frontend.js",
	"./product-categories/frontend.js": "./src/block/product-categories/frontend.js",
	"./product-featured/frontend.js": "./src/block/product-featured/frontend.js",
	"./products-carousel/frontend.js": "./src/block/products-carousel/frontend.js",
	"./products-deals-carousel/frontend.js": "./src/block/products-deals-carousel/frontend.js",
	"./products-list/frontend.js": "./src/block/products-list/frontend.js",
	"./products-simple/frontend.js": "./src/block/products-simple/frontend.js",
	"./products/frontend.js": "./src/block/products/frontend.js",
	"./single-product-carousel/frontend.js": "./src/block/single-product-carousel/frontend.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/block sync recursive frontend\\.js$";